// extracted by mini-css-extract-plugin
export default {"root":"d30KZtT0iZXNlrhK7ERQ","icon":"gVzdLxW_bIHsbKl5maxJ","text":"ZvAWL4kAjKCTuCQFRyKs"};